export default __webpack_public_path__ + "static/media/IMG-20241210-WA0035.34c746e3.jpg";